/* global document, window */

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import GoogleTagManager from '@redux-beacon/google-tag-manager';
// eslint-disable-next-line no-unused-vars
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import { createMiddleware /* createMetaReducer */ } from 'redux-beacon';
import createSagaMiddleware from 'redux-saga';

import AppErrorBoundary from './AppErrorBoundary';
import NoApp from './NoApp';
import Routes from './Routes';
import reducers from './index-reducers';
import rootSaga from './index-sagas';
import { eventsMap } from './redux/gtm/gtm';
import UrlWidgets from './widgets/UrlWidgets';

require('../public/assets/beta/scss/platform/c7.min.scss');

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const sagaMiddleware = createSagaMiddleware();

const gtm = GoogleTagManager();

let gtmMiddleware = () => (next) => (action) => next(action);
if (window.dataLayer) {
  gtmMiddleware = createMiddleware(eventsMap, gtm);
}

const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(sagaMiddleware, gtmMiddleware))
);
sagaMiddleware.run(rootSaga);

const c7Content = document.getElementById('c7-content');

const scriptTag = document.getElementById('c7-javascript');
if (!scriptTag) {
  // eslint-disable-next-line no-console
  console.error('Invalid Commerce7 Script Tag Configuration');
  throw Error('Invalid Commerce7 Script Tag Configuration');
}

const tenantId = scriptTag.getAttribute('data-tenant');
if (!tenantId) {
  // eslint-disable-next-line no-console
  console.error('Invalid Commerce7 Script Tag Configuration');
  throw Error('Invalid Commerce7 Script Tag Configuration');
}

if (c7Content) {
  const root = createRoot(c7Content);
  root.render(
    <Provider store={store}>
      <AppErrorBoundary>
        <UrlWidgets />
        <Routes />
      </AppErrorBoundary>
    </Provider>
  );
} else {
  const content = document.createElement('div');
  content.id = 'c7-no-content';
  document.body.appendChild(content);
  const container = document.getElementById('c7-no-content');
  const root = createRoot(container);

  /* Create Modal Div */
  const modal = document.createElement('div');
  modal.id = 'c7-modal';
  document.body.appendChild(modal);
  root.render(
    <Provider store={store}>
      <AppErrorBoundary>
        <UrlWidgets />
        <NoApp />
      </AppErrorBoundary>
    </Provider>
  );
}
